import styled, { css } from 'styled-components';
import { i as invertedFocusOutline } from '../theme/style-mixins/FocusIndicator/invertedFocusOutline-BxN_kWq6.js';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { i as isNotMobile } from '../theme/style-mixins/isMobile/isNotMobile-B9hACxZW.js';

const TriggerButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-dc6urg-0"
})(["background:transparent;border:none;cursor:pointer;padding:0;margin:0;min-width:", ";width:", ";color:", ";", " :hover{color:", ";}:active{color:", ";}:focus-visible{", "}"], ({
  theme
}) => theme.controls.height.small.default, ({
  $fullWidthTrigger
}) => $fullWidthTrigger ? '100%' : 'auto', ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.inverted : theme.icon.color.tertiary, isNotMobile(css(["transform:translateY(2px);"])), ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.invertedHover : theme.icon.color.tertiaryHover, ({
  theme,
  $inverted
}) => $inverted ? theme.icon.color.invertedActive : theme.icon.color.tertiaryActive, ({
  $inverted
}) => $inverted ? invertedFocusOutline : focusOutline);
const TooltipButton = /*#__PURE__*/styled(TriggerButton).withConfig({
  componentId: "sc-storm-ui-40025937__sc-dc6urg-1"
})(["display:inline-flex;justify-content:center;align-items:center;border-radius:", ";width:", ";"], ({
  theme
}) => theme.border.radius.round, ({
  theme
}) => theme.controls.height.small.default);
const TooltipIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-dc6urg-2"
})([""]);
TooltipIcon.displayName = 'TooltipIcon';

export { TriggerButton as T, TooltipButton as a, TooltipIcon as b };
//# sourceMappingURL=HelpTip.styles-DNgS_p7J.js.map
